export default __webpack_public_path__ + "static/media/banner.f98da3b0.jpg";